module.exports = __webpack_public_path__ + "static/media/spinner.396f4d78.svg";